module.exports = __webpack_public_path__ + "static/media/ErrorTraingle.64f5f1d7.svg";